module.exports = __webpack_public_path__ + "static/media/pain_detect_area.bc7c8ca8.png";